import React, { useState, useEffect, useRef, useCallback } from 'react';
import BtnStatusError from '../../items/BtnStatusError.js';
import { useTranslation } from 'react-i18next';
import EmailSendBtn from '../../items/EmailSendBtn.js';
import axios from 'axios';
import * as Constants from '../../constants.js';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import LoopIcon from '@mui/icons-material/Loop';
import SettingsIcon from '@mui/icons-material/Settings';
import ModalWithCard from '../../items/ModalWithCard.js';

import DownloadIcon from '@mui/icons-material/Download';
import InfoIcon from '@mui/icons-material/Info';
import HelpIcon from '@mui/icons-material/Help';
import DescriptionIcon from '@mui/icons-material/Description';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import InputIcon from '@mui/icons-material/Input';

const Compiler = ({ event, getToken, userdata }) => {
  const { t, i18n } = useTranslation();
  const [logdata, setLogdata] = React.useState([]);
  const [profiledata, setProfiledata] = React.useState({});
  const [allmodeinfo, setAllmodeinfo] = React.useState({});
  const [acc, setAcc] = React.useState({});
  const [firm, setFirm] = React.useState('esp8266_4mb');
  const [showLogModal, setShowLogModal] = useState(false);
  const [logTextMsg, setLogTextMsg] = useState('');
  const [firmAddresses, setFirmAddresses] = React.useState({});
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [info, setInfo] = useState({});
  const [userfiles, setUserfiles] = useState([]);
  const [showFileModal, setShowFileModal] = useState(false);
  const [orderToShow, setOrderToShow] = useState({});
  const [showFlasherModal, setShowFlasherModal] = useState(false);

  const st = {
    0: <></>,
    1: (
      <SettingsIcon class='fill-blue-400 animate-spin hover:animate-spin h-6 w-6 hover:fill-blue-600 hover:scale-110'></SettingsIcon>
    ),
    2: <CheckIcon class='fill-green-400 h-6 w-6 hover:fill-green-600 hover:scale-110'></CheckIcon>,
    3: <CloseIcon class='fill-red-400 h-6 w-6  hover:fill-red-600 hover:scale-110'></CloseIcon>,
  };

  useEffect(() => {
    const get = async () => {
      await getProfileData();
      await getLogData();
      await getModInfo();
    };
    get();
  }, []);

  var updateInterval;

  const periodicTask = async () => {
    await getLogData();
  };

  //запрос данных профиля
  const getProfileData = async () => {
    const token = getToken();
    if (token) {
      const bearer = {
        headers: { Authorization: 'Bearer ' + token },
      };
      await axios
        .get(Constants.iotmanager_url + '/compiler/profile', bearer)
        .then((res) => {
          res.data.message.username = userdata.username;
          setProfiledata(res.data);
          console.log(res.data);
        })
        .catch((err) => console.log(err?.response?.data?.message));
    } else {
      console.log('User not login');
    }
  };

  //запрос истории прошивок
  const getLogData = async () => {
    const token = getToken();
    if (token) {
      const bearer = {
        headers: { Authorization: 'Bearer ' + token },
      };
      await axios
        .get(Constants.iotmanager_url + '/compiler/userorders', bearer)
        .then((res) => {
          setLogdata(res.data);
          checkStatus(res.data);
        })
        .catch((err) => console.log(err?.response?.data?.message));
    } else {
      console.log('User not login');
    }
  };

  function checkStatus(logdata) {
    if (logdata[0].processed) {
      clearInterval(updateInterval);
      console.log('no interval - all task done');
    } else {
      console.log('non completed task exist!');
      if (!updateInterval) {
        console.log('interval checking started');
        updateInterval = setInterval(periodicTask, 10000);
      }
    }
  }

  const getModInfo = async () => {
    await axios
      .get(Constants.iotmanager_url + '/compiler/allmodinfo')
      .then((res) => {
        setAllmodeinfo(res.data.message);
      })
      .catch((err) => console.log(err?.response?.data?.message));
  };

  function onChange(val) {
    setFirm(val);
    setProfiledata({
      ...profiledata,
      message: {
        ...profiledata.message,
        projectProp: {
          ...profiledata.message.projectProp,
          platformio: {
            ...profiledata.message.projectProp.platformio,
            default_envs: val,
          },
        },
      },
    });
  }

  //правильный пример перепеси одного элемента вложенного массива без мутации
  const changeArrElement = (path, val, name) => {
    setProfiledata({
      ...profiledata,
      message: {
        ...profiledata.message,
        modules: {
          ...profiledata.message.modules,
          [name]: [
            ...profiledata.message.modules[name].map((el) => ({
              ...el,
              active: el.path === path ? val : el.active,
            })),
          ],
        },
      },
    });
  };

  const onSuccess = async (data) => {
    await getLogData();
  };

  const getLogFiles = async (username, orderid, file) => {
    const token = getToken();
    if (token) {
      const bearer = {
        headers: { Authorization: 'Bearer ' + token },
      };
      await axios
        .get(Constants.iotmanager_url + '/compiler/file/builds/' + orderid + '/' + file, bearer)
        .then((res) => {
          setLogTextMsg(res.data.message);
          setShowLogModal(true);
        })
        .catch((err) => console.log(err?.response?.data?.message));
    } else {
      console.log('User not login');
    }
  };

  const showLog = async (ord, file) => {
    await getLogFiles(ord.username, ord.orderId, file);
  };

  const showInfo = async (ord) => {
    setShowInfoModal(true);
    setInfo(ord);
    setAdresses(ord.projectProp.platformio.default_envs);
  };

  const showFlasher = async (ord) => {
    window.location.replace('https://portaller.cloud/flasher/?id=' + ord.orderId);
  };

  function setAdresses(firmName) {
    profiledata?.message?.projectProp?.platformio?.envs.map((envs, index) => {
      if (envs.name === firmName) setFirmAddresses(envs);
    });
  }

  const showFiles = async (ord) => {
    const token = getToken();
    if (token) {
      const bearer = {
        headers: { Authorization: 'Bearer ' + token },
      };
      await axios
        .get(Constants.iotmanager_url + '/compiler/filelist/builds/' + ord.orderId, bearer)
        .then((res) => {
          setUserfiles(res.data.message);
          setOrderToShow(ord);
          setShowFileModal(true);
        })
        .catch((err) => console.log(err?.response?.data?.message));
    } else {
      console.log('User not login');
    }
  };

  const delOrder = async (ord) => {
    const token = getToken();
    if (token) {
      const bearer = {
        headers: { Authorization: 'Bearer ' + token },
      };
      await axios
        .get(Constants.iotmanager_url + '/compiler/delete/builds/' + ord.orderId, bearer)
        .then(async (res) => {
          await getLogData();
        })
        .catch((err) => console.log(err?.response?.data?.message));
    } else {
      console.log('User not login');
    }
  };

  const setSsid = (e) => {
    setProfiledata({
      ...profiledata,
      message: {
        ...profiledata.message,
        iotmSettings: {
          ...profiledata.message.iotmSettings,
          routerssid: e,
        },
      },
    });
  };

  const setPass = (e) => {
    setProfiledata({
      ...profiledata,
      message: {
        ...profiledata.message,
        iotmSettings: {
          ...profiledata.message.iotmSettings,
          routerpass: e,
        },
      },
    });
  };

  const setComment = (e) => {
    setProfiledata({
      ...profiledata,
      message: {
        ...profiledata.message,
        comment: e,
      },
    });
  };

  const setName = (e) => {
    setProfiledata({
      ...profiledata,
      message: {
        ...profiledata.message,
        iotmSettings: {
          ...profiledata.message.iotmSettings,
          name: e,
        },
      },
    });
  };

  const isBoardSupported = (module) => {
    let boardsGroup = firm.substring(0, 5) + '*';
    if (allmodeinfo[module.path]?.usedLibs[firm]) {
      if (allmodeinfo[module.path]?.usedLibs[firm][0] === 'exclude') {
        return false;
      } else {
        return true;
      }
    } else if (allmodeinfo[module.path]?.usedLibs[boardsGroup]) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      <div className='flex items-center justify-center'>
        <select
          onChange={(e) => onChange(e.target.value)}
          value={firm}
          className='select text-center select-sm select-bordered w-1/2 bg-white text-gray-900 border-gray-300 mt-2 mb-4'>
          <>
            {profiledata?.message?.projectProp?.platformio?.envs.map((envs, index) => {
              return (
                <option key={index} value={envs.name}>
                  {envs.name}
                </option>
              );
            })}
          </>
        </select>
      </div>

      <div className='join join-vertical mb-2 w-full'>
        <div className='collapse collapse-arrow join-item border border-gray-300 text-gray-900'>
          <input
            checked={acc.zero}
            onChange={(e) => setAcc({ ...acc, zero: e.target.checked })}
            type='checkbox'
          />

          <div className='collapse-title text-lg align-middle font-medium'>Настройки wifi</div>
          <div className='collapse-content'>
            <div className='overflow-x-auto'>
              <div class='grid gap-2 w-full grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 justify-items-end items-center justify-center pr-0 sm:pr-5 lg:pr-20 xl:pr-40 2xl:pr-40 mb-4'>
                <p class='font-bold text-sm w-32 sm:w-32 lg:w-32 xl:w-full 2xl:w-full text-right truncate'>
                  Название WiFi
                </p>
                <input
                  value={profiledata?.message?.iotmSettings?.routerssid}
                  onChange={(e) => setSsid(e.target.value)}
                  class='shadow appearance-none border rounded w-full h-8 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
                  id='routerssid'
                  type='text'
                  placeholder={'iot'}></input>
                <p class='font-bold text-sm w-32 sm:w-32 lg:w-32 xl:w-full 2xl:w-full text-right truncate'>
                  Пароль WiFi
                </p>
                <input
                  value={profiledata?.message?.iotmSettings?.routerpass}
                  onChange={(e) => setPass(e.target.value)}
                  class='shadow appearance-none border rounded w-full h-8 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
                  id='routerpass'
                  type='text'
                  placeholder={'123456'}></input>
                <p class='font-bold text-sm w-32 sm:w-32 lg:w-32 xl:w-full 2xl:w-full text-right truncate'>
                  Комментарий
                </p>
                <input
                  value={profiledata?.message?.comment}
                  onChange={(e) => setComment(e.target.value)}
                  class='shadow appearance-none border rounded w-full h-8 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
                  id='comment'
                  type='text'
                  placeholder={'Освещение'}></input>
                <p class='font-bold text-sm w-32 sm:w-32 lg:w-32 xl:w-full 2xl:w-full text-right truncate'>
                  Название устройства
                </p>
                <input
                  value={profiledata?.message?.iotmSettings?.name}
                  onChange={(e) => setName(e.target.value)}
                  class='shadow appearance-none border rounded w-full h-8 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
                  id='name'
                  type='text'
                  placeholder={'iot'}></input>
              </div>
            </div>
          </div>
        </div>

        <div className='collapse collapse-arrow join-item border border-gray-300 text-gray-900'>
          <input
            checked={acc.one}
            onChange={(e) => setAcc({ ...acc, one: e.target.checked })}
            type='checkbox'
          />

          <div className='collapse-title text-lg align-middle font-medium'>
            Виртуальные элементы
          </div>
          <div className='collapse-content'>
            <div className='overflow-x-auto'>
              <table className='table'>
                <tbody>
                  {profiledata?.message?.modules?.virtual_elments?.map((module, cIndex) => (
                    <tr>
                      <td class='p-1 w-1/12'>
                        {isBoardSupported(module) && (
                          <div class='flex items-center justify-center align-baseline'>
                            <input
                              type='checkbox'
                              onChange={(e) =>
                                changeArrElement(module.path, e.target.checked, 'virtual_elments')
                              }
                              checked={module.active}
                              className='checkbox checkbox-xs'
                            />
                          </div>
                        )}
                      </td>
                      <th
                        class={
                          isBoardSupported(module)
                            ? 'pl-1 p-1 w-2/12'
                            : 'pl-1 p-1 w-2/12 text-gray-300'
                        }>
                        {module.path.substring(
                          module.path.lastIndexOf('/') + 1,
                          module.path.length,
                        )}
                      </th>
                      <td
                        class={
                          isBoardSupported(module) ? 'p-1 w-9/12' : 'p-1 w-9/12 text-gray-300'
                        }>
                        {allmodeinfo[module.path]?.about?.title}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className='collapse collapse-arrow join-item border border-gray-300 text-gray-900'>
          <input
            checked={acc.two}
            onChange={(e) => setAcc({ ...acc, two: e.target.checked })}
            type='checkbox'
          />
          <div className='collapse-title text-lg font-medium'>Сенсоры</div>
          <div className='collapse-content'>
            <div className='overflow-x-auto'>
              <table className='table'>
                <tbody>
                  {profiledata?.message?.modules?.sensors?.map((module, cIndex) => (
                    <tr>
                      <td class='p-1 w-1/12'>
                        {isBoardSupported(module) && (
                          <div class='flex items-center justify-center align-baseline'>
                            <input
                              type='checkbox'
                              onChange={(e) =>
                                changeArrElement(module.path, e.target.checked, 'sensors')
                              }
                              checked={module.active}
                              className='checkbox checkbox-xs'
                            />
                          </div>
                        )}
                      </td>
                      <th
                        class={
                          isBoardSupported(module)
                            ? 'pl-1 p-1 w-2/12'
                            : 'pl-1 p-1 w-2/12 text-gray-300'
                        }>
                        {module.path.substring(
                          module.path.lastIndexOf('/') + 1,
                          module.path.length,
                        )}
                      </th>
                      <td
                        class={
                          isBoardSupported(module) ? 'p-1 w-9/12' : 'p-1 w-9/12 text-gray-300'
                        }>
                        {allmodeinfo[module.path]?.about?.title}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className='collapse collapse-arrow join-item border border-gray-300 text-gray-900'>
          <input
            checked={acc.tr}
            onChange={(e) => setAcc({ ...acc, tr: e.target.checked })}
            type='checkbox'
          />
          <div className='collapse-title text-lg font-medium'>Исполнительные устройства</div>
          <div className='collapse-content'>
            <div className='overflow-x-auto'>
              <table className='table'>
                <tbody>
                  {profiledata?.message?.modules?.executive_devices?.map((module, cIndex) => (
                    <tr>
                      <td class='p-1 w-1/12'>
                        {isBoardSupported(module) && (
                          <div class='flex items-center justify-center align-baseline'>
                            <input
                              type='checkbox'
                              onChange={(e) =>
                                changeArrElement(module.path, e.target.checked, 'executive_devices')
                              }
                              checked={module.active}
                              className='checkbox checkbox-xs'
                            />
                          </div>
                        )}
                      </td>
                      <th
                        class={
                          isBoardSupported(module)
                            ? 'pl-1 p-1 w-2/12'
                            : 'pl-1 p-1 w-2/12 text-gray-300'
                        }>
                        {module.path.substring(
                          module.path.lastIndexOf('/') + 1,
                          module.path.length,
                        )}
                      </th>
                      <td
                        class={
                          isBoardSupported(module) ? 'p-1 w-9/12' : 'p-1 w-9/12 text-gray-300'
                        }>
                        {allmodeinfo[module.path]?.about?.title}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className='collapse collapse-arrow join-item border border-gray-300 text-gray-900'>
          <input
            checked={acc.four}
            onChange={(e) => setAcc({ ...acc, four: e.target.checked })}
            type='checkbox'
          />
          <div className='collapse-title text-lg font-medium'>Экраны</div>
          <div className='collapse-content'>
            <div className='overflow-x-auto'>
              <table className='table'>
                <tbody>
                  {profiledata?.message?.modules?.screens?.map((module, cIndex) => (
                    <tr>
                      <td class='p-1 w-1/12'>
                        {isBoardSupported(module) && (
                          <div class='flex items-center justify-center align-baseline'>
                            <input
                              type='checkbox'
                              onChange={(e) =>
                                changeArrElement(module.path, e.target.checked, 'screens')
                              }
                              checked={module.active}
                              className='checkbox checkbox-xs'
                            />
                          </div>
                        )}
                      </td>
                      <th
                        class={
                          isBoardSupported(module)
                            ? 'pl-1 p-1 w-2/12'
                            : 'pl-1 p-1 w-2/12 text-gray-300'
                        }>
                        {module.path.substring(
                          module.path.lastIndexOf('/') + 1,
                          module.path.length,
                        )}
                      </th>
                      <td
                        class={
                          isBoardSupported(module) ? 'p-1 w-9/12' : 'p-1 w-9/12 text-gray-300'
                        }>
                        {allmodeinfo[module.path]?.about?.title}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <BtnStatusError
        onSuccess={onSuccess}
        params={{
          url: Constants.iotmanager_url + '/compiler/order',
          singleurl: true,
          data: profiledata.message,
          token: getToken(),
          text: 'Поставить в очередь',
        }}></BtnStatusError>

      {logdata ? (
        <div className='overflow-x-auto mt-4'>
          <table className='table text-gray-90'>
            {/* head */}
            <thead className='text-gray-600'>
              <tr>
                <th>Название</th>
                <th>Версия</th>
                <th>Время</th>
                <th>Комментарий</th>
                <th>Подготовка</th>
                <th>Сборка build</th>
                <th>Сборка fs</th>
                <th>Скачать</th>
                <th>Инфо</th>
                <th>Прошить</th>
                <th>Удалить</th>
              </tr>
            </thead>
            <tbody>
              {/* rows */}

              {logdata.map((ord, cIndex) => (
                <>
                  <tr>
                    <td class='p-1'>{ord.projectProp.platformio.default_envs}</td>
                    <td class='p-1'>{ord.ver}</td>
                    <td class='p-1'>
                      <p class='line-clamp-1'>
                        {new Date(ord.dateAdded).toLocaleString('ru', {
                          timeZone: 'Europe/Vienna',
                        })}
                      </p>
                    </td>
                    <td class='p-1'>
                      <p class='line-clamp-1'>{ord.comment}</p>
                    </td>

                    {ord.status.preparation === 0 &&
                    ord.status.build === 0 &&
                    ord.status.fs === 0 ? (
                      <>
                        <td class='p-1'>
                          <p class='font-bold text-green-500'>{'Ожидание очереди...'}</p>
                        </td>
                      </>
                    ) : (
                      <>
                        <td class='p-1'>
                          <div onClick={() => showLog(ord, 'py.txt')}>
                            {st[ord.status.preparation]}
                          </div>
                        </td>
                        <td class='p-1'>
                          <div onClick={() => showLog(ord, 'build.txt')}>
                            {st[ord.status.build]}
                          </div>
                        </td>
                        <td class='p-1'>
                          <div onClick={() => showLog(ord, 'fs.txt')}>{st[ord.status.fs]} </div>
                        </td>
                        {ord.status.build === 2 &&
                        ord.status.preparation === 2 &&
                        ord.status.fs === 2 ? (
                          <>
                            <td class='p-1'>
                              <div onClick={() => showFiles(ord)}>
                                <DownloadIcon class='fill-blue-400 h-6 w-6 hover:fill-blue-600 hover:scale-110'></DownloadIcon>
                              </div>
                            </td>
                            <td class='p-1'>
                              <div onClick={() => showInfo(ord)}>
                                <HelpIcon class='fill-blue-400 h-6 w-6 hover:fill-blue-600 hover:scale-110'></HelpIcon>
                              </div>
                            </td>
                            <td class='p-1'>
                              <a
                                target='_blank'
                                href={'https://flasher.iotmanager.org/?id=' + ord.orderId}>
                                <InputIcon class='fill-blue-400 h-6 w-6 hover:fill-blue-600 hover:scale-110'></InputIcon>
                              </a>
                            </td>
                          </>
                        ) : (
                          <>
                            <td class='p-1'></td>
                            <td class='p-1'></td>
                            <td class='p-1'></td>
                          </>
                        )}
                        {ord.processed && (
                          <td class='p-1'>
                            <div onClick={() => delOrder(ord)}>
                              <DeleteForeverIcon class='fill-red-400 h-6 w-6 hover:fill-red-600 hover:scale-110'></DeleteForeverIcon>
                            </div>
                          </td>
                        )}
                      </>
                    )}
                  </tr>
                </>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div class='flex items-center justify-center'>
          <span className='loading loading-dots loading-lg'></span>
        </div>
      )}

      {showInfoModal && (
        <ModalWithCard setShowModal={setShowInfoModal}>
          <h3></h3>
          <div className='overflow-x-auto'>
            <table className='table table-xs'>
              <tbody>
                <tr>
                  <td>Прошивка:</td>
                  <td>{info.projectProp.platformio.default_envs}</td>
                </tr>
                <tr>
                  <td>WiFi:</td>
                  <td>{info.iotmSettings.routerssid}</td>
                </tr>
                <tr>
                  <td>Пароль WiFi:</td>
                  <td>{info.iotmSettings.routerpass}</td>
                </tr>
                <tr>
                  <td>ID сборки:</td>
                  <td>{info.orderId}</td>
                </tr>

                {Object.keys(firmAddresses).map((key, i) => (
                  <>
                    {key !== 'name' && (
                      <tr class='bg-green-50' key={i}>
                        <td>
                          {key}
                          {'.bin'}
                        </td>
                        <td>{firmAddresses[key]}</td>
                      </tr>
                    )}
                  </>
                ))}

                {info.modules.virtual_elments.map((mod, i) => (
                  <>
                    {mod.active &&
                      allmodeinfo[mod.path]?.usedLibs[info.projectProp.platformio.default_envs] && (
                        <tr class='bg-gray-50' key={i}>
                          <td>
                            {mod.path.substring(mod.path.lastIndexOf('/') + 1, mod.path.length)}
                          </td>
                          <td>{allmodeinfo[mod.path]?.about?.title}</td>
                        </tr>
                      )}
                  </>
                ))}

                {info.modules.sensors.map((mod, i) => (
                  <>
                    {mod.active &&
                      allmodeinfo[mod.path]?.usedLibs[info.projectProp.platformio.default_envs] && (
                        <tr class='bg-yellow-50' key={i}>
                          <td>
                            {mod.path.substring(mod.path.lastIndexOf('/') + 1, mod.path.length)}
                          </td>
                          <td>{allmodeinfo[mod.path]?.about?.title}</td>
                        </tr>
                      )}
                  </>
                ))}

                {info.modules.executive_devices.map((mod, i) => (
                  <>
                    {mod.active &&
                      allmodeinfo[mod.path]?.usedLibs[info.projectProp.platformio.default_envs] && (
                        <tr class='bg-gray-50' key={i}>
                          <td>
                            {mod.path.substring(mod.path.lastIndexOf('/') + 1, mod.path.length)}
                          </td>
                          <td>{allmodeinfo[mod.path]?.about?.title}</td>
                        </tr>
                      )}
                  </>
                ))}

                {info.modules.screens.map((mod, i) => (
                  <>
                    {mod.active &&
                      allmodeinfo[mod.path]?.usedLibs[info.projectProp.platformio.default_envs] && (
                        <tr class='bg-yellow-50' key={i}>
                          <td>
                            {mod.path.substring(mod.path.lastIndexOf('/') + 1, mod.path.length)}
                          </td>
                          <td>{allmodeinfo[mod.path]?.about?.title}</td>
                        </tr>
                      )}
                  </>
                ))}
              </tbody>
            </table>
          </div>
        </ModalWithCard>
      )}
      {showLogModal && (
        <ModalWithCard setShowModal={setShowLogModal}>
          <div class='no-tailwindcss-base' dangerouslySetInnerHTML={{ __html: logTextMsg }}></div>
        </ModalWithCard>
      )}
      {showFileModal && (
        <ModalWithCard setShowModal={setShowFileModal}>
          <>
            {userfiles.map((file, cIndex) => (
              <table className='table table-xs text-gray-90'>
                <tbody>
                  <tr>
                    {file.includes('.bin') && (
                      <>
                        <td class='w-full'>
                          <>
                            <div class='flex items-center mb-2' key={cIndex}>
                              <SettingsIcon class='fill-green-400 h-6 w-6'></SettingsIcon>
                              <p class='ml-2 text-black-800'>{file}</p>
                            </div>
                          </>
                        </td>
                        <td>
                          <a
                            href={
                              Constants.iotmanager_url +
                              '/compiler/userdata/builds/' +
                              orderToShow.orderId +
                              '/' +
                              file
                            }
                            download={file}>
                            <DownloadIcon class='fill-blue-400 h-6 w-6 hover:fill-blue-600 hover:scale-110'></DownloadIcon>
                          </a>
                        </td>
                      </>
                    )}
                  </tr>
                </tbody>
              </table>
            ))}
          </>
        </ModalWithCard>
      )}
    </>
  );
};

export default Compiler;
